import { feature as topoFeature } from 'topojson-client';
import world from 'world-atlas/countries-50m.json';
import { bbox, booleanPointInPolygon, point } from '@turf/turf';

const ISO_NUMERIC_TO_ALPHA2 = {
  '008':'AL','040':'AT','056':'BE','070':'BA','100':'BG','112':'BY','191':'HR','196':'CY','203':'CZ','208':'DK','233':'EE','246':'FI','250':'FR','276':'DE','300':'GR','348':'HU','372':'IE','380':'IT','428':'LV','438':'LI','440':'LT','442':'LU','470':'MT','492':'MC','498':'MD','499':'ME','528':'NL','578':'NO','616':'PL','620':'PT','642':'RO','643':'RU','674':'SM','688':'RS','703':'SK','705':'SI','724':'ES','752':'SE','756':'CH','792':'TR','804':'UA','807':'MK','826':'GB','336':'VA'
};
const COUNTRY_NAMES_PL = { PL:'Polska', CZ:'Czechy', SK:'Słowacja', DE:'Niemcy', HR:'Chorwacja', SI:'Słowenia', AT:'Austria', HU:'Węgry', LT:'Litwa', LV:'Łotwa', EE:'Estonia', UA:'Ukraina', BY:'Białoruś', RO:'Rumunia', BG:'Bułgaria', IT:'Włochy', FR:'Francja', NL:'Holandia', BE:'Belgia', DK:'Dania', SE:'Szwecja', NO:'Norwegia', CH:'Szwajcaria', BA:'Bośnia i Hercegowina', RS:'Serbia', ME:'Czarnogóra', AL:'Albania', MK:'Macedonia Północna', GR:'Grecja', ES:'Hiszpania', PT:'Portugalia', GB:'Wielka Brytania', IE:'Irlandia', TR:'Turcja' };
let indexedCountries;
function loadCountries() {
  if (indexedCountries) return indexedCountries;
  const collection = topoFeature(world, world.objects.countries);
  indexedCountries = collection.features.map(feature => {
    const id = String(feature.id || '').padStart(3, '0');
    const code = ISO_NUMERIC_TO_ALPHA2[id] || '';
    return { feature, code, name: COUNTRY_NAMES_PL[code] || feature.properties?.name || code || 'Nieznane', bbox: bbox(feature) };
  }).filter(item => item.code);
  return indexedCountries;
}
export function countryAt(lon, lat) {
  if (!Number.isFinite(lon) || !Number.isFinite(lat)) return { code:'', name:'Nieznane' };
  const p = point([lon, lat]);
  for (const item of loadCountries()) {
    const [minX,minY,maxX,maxY] = item.bbox;
    if (lon < minX || lon > maxX || lat < minY || lat > maxY) continue;
    if (booleanPointInPolygon(p, item.feature)) return { code:item.code, name:item.name };
  }
  return { code:'', name:'Nieznane' };
}
export function countryName(code) { return COUNTRY_NAMES_PL[code] || code || 'Nieznane'; }
